import React, { useEffect, useState } from "react";
import styles from "./navbar.module.scss";
import logo from "../../assests/krihameghamLogo.png.png";
import { NavLink, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import mobileLogo from "../../assests/meghamMobileViewLogo.png";
import { Close } from "@mui/icons-material";
import { useLocation } from "react-router-dom";

const Navbar = () => {
  const [isActive, setisActive] = useState("#hero");
  const [hide, sethide] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navigateBlog = () => {
    navigate("/blog");
  };

  const navigateHome = () => {
    window.location.hash = "";
    navigate("/");
  };

  const navigateCareer = () => {
    window.location.hash = "";
    navigate("/careers");
  };

  useEffect(() => {
    let updateHash = () => setisActive(window.location.hash);
    window.addEventListener("hashchange", updateHash);
    return () => window.removeEventListener("hashchange", updateHash);
  }, []);

  const openMenu = () => {
    sethide(!hide);
  };

  const navigateLogin = () => {
    navigate("/login");
  };

  const handleAboutClick = () => {
    if (location.pathname === "/careers") {
      const section = document.getElementById("about");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: "about" } });
    }
    sethide(hide)
  };

  const handleContactClick = () => {
    if (location.pathname === "/careers") {
      const section = document.getElementById("contact");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: "contact" } });
    }
    sethide(hide)
  };

  const handleBlogClick = () => {
    if (location.pathname === "/blog") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/blog#blogTop");
    }
    sethide(hide)
  };

  const handleServicesClick = () => {
    const section = document.getElementById("ourServices");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: "ourServices" } });
    }
    sethide(hide)
  };

  const isSectionActive = (section) => location.hash === `#${section}`;

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <div onClick={navigateHome} className={styles.logo}>
            <img src={logo} alt="" />
          </div>
        </div>
        <div className={styles.middle}>
          <NavLink
            to="/"
            className={() =>
              location.pathname === "/" &&
              !isSectionActive("#about") &&
              !isSectionActive("#contact")
                ? styles.navActive
                : styles.NavdeActive
            }
          >
            <div>Home</div>
          </NavLink>
          <div
            onClick={handleServicesClick}
            className={
              isSectionActive("#ourServices")
                ? styles.navActive
                : styles.NavdeActive
            }
          >
            <div>Services</div>
          </div>
          <div
            onClick={handleAboutClick}
            className={
              isSectionActive("#about") ? styles.navActive : styles.NavdeActive
            }
          >
            About us
          </div>
          <div
            onClick={handleContactClick}
            className={
              isSectionActive("#contact")
                ? styles.navActive
                : styles.NavdeActive
            }
          >
            Contact us
          </div>
          <NavLink
            to="/careers"
            className={() =>
              location.pathname === "/careers" &&
              !isSectionActive("#about") &&
              !isSectionActive("#contact")
                ? styles.navActive
                : styles.NavdeActive
            }
          >
            <div>Careers</div>
          </NavLink>
          <div
            onClick={handleBlogClick}
            className={
              location.pathname === "/blog"
                ? styles.navActive
                : styles.NavdeActive
            }
          >
            <div>Blogs</div>
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.loginButton} onClick={navigateLogin}>
            Login
          </div>
        </div>
        <div className={!hide ? styles.mobileMenu : styles.mobileMenuClose}>
          <div className={styles.menuTop}>
            <img src={mobileLogo} alt="" className={styles.logo} />
            <Close style={{ marginRight: 20 }} onClick={openMenu} />
          </div>
          <div onClick={navigateHome}>Home</div>
          <div onClick={handleServicesClick}>Services</div>
          <div onClick={handleAboutClick}>About us</div>
          <div onClick={handleContactClick}>Contact</div>
          <div onClick={navigateCareer}>Careers</div>
          <div onClick={navigateBlog}>Blog</div>
        </div>
        <div className={styles.menuIcon}>
          <MenuIcon className={styles.icon} onClick={openMenu} />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
